import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select, Tabs, Alert, DatePicker, Col, Row, Tooltip } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import '../css/form.css';
import EditableTable from '../components/EditableTable';
import { ActionColumn, dataSource, entriesColumns } from '../utils/tableMockData';
import { MdPublish } from "react-icons/md";
import { BiReset } from "react-icons/bi";
import { FaCloudArrowUp } from "react-icons/fa6";
import useJournalEntriesAPI from '../apis/journalEntriesAPI';
import EventEmitter from '../utils/eventEmitter';
import dayjs from 'dayjs';
import EntryTable from '../components/EntryTable';
// import customParseFormat from 'dayjs/plugin/customParseFormat';
// dayjs.extend(customParseFormat);




const JournalEntries = () => {
  const { journals, accounts, entry, taxes, analytics } = useLoaderData();
  entry['accounting_date'] = entry.accounting_date ? dayjs(entry['accounting_date'], 'YYYY-MM-DD') : '';
  
  const [journalEntries, setJournalEntries] = useState(entry.transactions ? entry.transactions : []);
  const [entryData, setEntryData] = useState(entry.number ? {status: entry.status} : {status: 'null'});
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const params = useParams();
  const [alert, setAlert] = useState({message: '', status: ''});
  const navigate = useNavigate();
  const { createEntry, postEntry, resetEntry } = useJournalEntriesAPI();
  const [tax, setTax] = useState([]);

  const onChange = (key) => console.log(key)


  
  const handleCreate = (status) => {
    let data = form.getFieldsValue();
    data['accounting_date'] = new Date(data.accounting_date).toLocaleDateString();
    let journal_code = journals.find(journal => journal._id === data.journal_id).code;
    data['journal_code'] = journal_code;
    const isEmpty = Object.values(data).includes('');
    // console.log(data)
    if (!isEmpty) {
      setAlert({...alert, message: ''});
      // let data = {...data};
      let journalEntries_ = [...journalEntries];
      data['transactions'] = journalEntries_;
      if (entryData.status === 'null') {
        delete data['status'];
        createEntry(data, success, error);
      }else {
        handlePost(data, status);
      }
    }else {
      setAlert({...alert, message: 'All fields are required!', status: 'warning'});
      setTimeout(() => {
        setAlert({...alert, message: ''});
      },10000)
    }
  } 

  const handlePost = (entryData_, status) => {
    let debitAmount = 0;
    let creditAmount = 0;
    journalEntries.forEach(entry => {
      if (entry.type === 'debit') {
        debitAmount += entry.amount * 1
      }else if (entry.type === 'credit') {
        creditAmount += entry.amount * 1
      }
    });
    if ((debitAmount > 0 && creditAmount > 0) && debitAmount === creditAmount) {
      setAlert({...alert, message: ''});
      entryData_['accounting_date'] = new Date(entryData_.accounting_date).toLocaleDateString();
      entryData_['status'] = status;

      postEntry(params.action, {entry: entryData_}, success, error);
    }else {
      setAlert({...alert, message: 'debit balance not equal credit balance', status: 'error'});
      setTimeout(() => {
        setAlert({ ...alert, message: '' })
      }, 10000)
    }
  }


  const handleResetToDraft = () => {
    let data = {entry: {status: 'draft', accounting_date: entry.accounting_date}};
    resetEntry(entry.number, data, success);
  }  

  // console.log(entry);
  useEffect(() => {
    EventEmitter.subscribe('createEntryResponseCode', data => {
      navigate('/accounting/journal-entries/'+data.replaceAll('/', '-'));
      setEntryData({...entryData, status: 'draft'});
    });

    EventEmitter.subscribe('posted-entry', data => {
      navigate('/accounting/journal-entries/'+data.replaceAll('/', '-'));
      setEntryData({...entryData, status: 'posted'});
    });

    EventEmitter.subscribe('reset-entry', data => {
      setEntryData({...entryData, status: data});
    });

    EventEmitter.subscribe('entry_error', data => {
      setAlert({...alert, message: data, status: 'error'});
      setTimeout(() => {
        setAlert({ ...alert, message: '' });
      }, 5000)
    });

    return () => {
      EventEmitter.unsubscribe('createEntryResponseCode');
      EventEmitter.unsubscribe('posted-entry');
      EventEmitter.unsubscribe('reset-entry');
      EventEmitter.unsubscribe('entry_error');
    }
  }, [])

  useEffect(() => {
    // if (transactions) {
    //   transactions.forEach((transaction) => {
    //     let account = accounts.find(
    //       (account) => account.code === transaction.account_id
    //     )
    //     form.setFieldValue(account.code, account.name)
    //   })
    // }
    window.addEventListener('popstate', (e) => {
      e.preventDefault()
      e.stopPropagation()
      navigate('/accounting/journal-items')
    })
    // return () => window.removeEventListener('popstate');
  }, [])

  // const handleResetToDraft = () => {
  //   setAlert({...alert, message: 'Not Implemented!', status: 'warning'});
  //     setTimeout(() => {
  //       setAlert({...alert, message: ''});
  //     },2000)
  // };

  const handleClose = () => setAlert('');

  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      {alert.message !== '' && (
        <Alert message={alert.message} type={alert.status} closable showIcon afterClose={handleClose}/>
      )}
      <div className='flex justify-between mb-3'>
        <div className='flex '>
          <h3 className='font-bold'>
            <Link
              to={'/accounting/journal-items'}
              className='whitespace-nowrap hover:underline font-medium text-sky-600 dark:text-white'
            >
              Journal Items
            </Link>{' '}
            / {params.action}
          </h3>
          <Tooltip
            title='save manually'
            placement='rightBottom'
            className='ms-1'
          >
            <Button
              onClick={handleCreate}
              type='text'
              htmlType='button'
              disabled={
                entryData.status === 'posted' || entryData.status === 'draft'
                  ? true
                  : false
              }
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>

        {/* <div class="arrow-block">
          <div class="arrow"></div>
          <div class="content">
            Your content goes here
          </div>
        </div> */}
        {/* <div class="arrow-block posted">
          <div class="arrow"></div>
          <div class="content">
            Posted
          </div>
        </div>

        <div class="arrow-block draft">
          <div class="arrow"></div>
          <div class="content">
            Draft
          </div>
        </div> */}
      </div>
      <div className='flex justify-between align-center'>
        <div>
        {entryData.status === 'draft' ?
          <Button onClick={()=>handleCreate('posted')} htmlType='button' icon={<MdPublish />}>Post</Button> :
          entryData.status === 'posted' && 
          <Button onClick={handleResetToDraft} htmlType='button' icon={<BiReset />}>Reset to Draft</Button>
        }
        </div>
        {entryData.status !== 'null' && (
          <div id='status-container '>
            <ul className='inner-wrapper'>
              <li
                className={
                  entryData.status === 'draft'
                    ? 'draft-disabled first draft draft-status'
                    : 'first draft-status draft-transparent'
                }
              >
                DRAFT
              </li>
              <li
                className={
                  entryData.status === 'posted'
                    ? 'posted posted-status'
                    : 'posted-status posted-transparent'
                }
              >
                POSTED
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className='mt-5 bg-white'>
        <Form 
          form={form}
          className='shadow p-3' 
          initialValues={entry.number ? entry : {}} 
          autoComplete="off"
          variant='borderless'
          disabled={entryData.status === 'posted' ? true : false }
        >
          <Row>
            <Col lg={{span: 11}}>
              <Form.Item label='Reference' name="reference" className='font-bold mb-2 column' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal' placeholder='Enter description here' />
              </Form.Item>
            </Col>
            <Col lg={{span: 11, offset: 1}}>
              <Form.Item label="Accounting Date" name="accounting_date" className='font-bold columns mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' />
              </Form.Item>
              <Form.Item label='Journal' name={'journal_id'} className='font-bold columns mb-2' required >
                <Select options={journals.map(journal => ({value: journal._id, label: journal.name}))} placeholder='select journal' variant='borderless' className='border-x-0 border-t-0 font-normal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            onChange={onChange}
            type='card'
            items={[
              {
                key: '1',
                label: 'Journal Items',
                children: <EntryTable dataSource={journalEntries} setJournalEntries={setJournalEntries} columns={entriesColumns} accounts={accounts} analytics={analytics} taxes={taxes} tax={tax} setTax={setTax} status={entryData.status}/>
                // children: <EditableTable name={'journal entries'} dataSource={journalEntries} setJournalEntries={setJournalEntries} columns={entriesColumns} accounts={accounts} analytics={analytics} taxes={taxes} tax={tax} setTax={setTax} status={entry.status}/>
                // children: <EditableTable dataSource={dataSource} setJournalEntries={setJournalEntries} defaultColumns={columns}/>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}
export default JournalEntries
